export default function getUnusedLogoDependencies({
    design,
    templateId,
    logoDependencies,
}) {
    const dependencyKeysInUse = [];

    for (const row of design.body.rows) {
        for (const column of row.columns) {
            for (const content of column.contents) {
                if (content.slug === 'keap#logo_tool') {
                    const { dependencyKey } = content.values.logoTool;

                    if (dependencyKey) dependencyKeysInUse.push(dependencyKey);
                }
            }
        }
    }

    return logoDependencies
        .filter((d) => d.templateId === templateId && !dependencyKeysInUse.includes(d.dependencyKey))
        .map((d) => d.dependencyKey);
}
